import React, { FC, useState, useMemo, useEffect } from 'react'
import { Button, Select, Form, message, Spin } from 'antd';
import styles from './index.module.scss'
import {
  quickPayDeliveryOptions,
  quickPayCountryOptions,
  quickPayRecipientNation,
  QuickPayDelivery,
} from '@/utils/defaultData';
import { DefaultInput, DefaultSelect, SelectPicture } from '@/components';
import { checkDisabled, regularData } from '@/utils/mainUtils';
import { useTranslation } from "react-i18next";
import HeadComponent from '@/components/HeadComponent/HeadComponent';
import FooterComponent from '@/components/FooterComponent';
import _ from 'lodash';
import { recipientApi } from '@/api';
import UploadComponent from '@/components/UploadComponent/UploadComponent';
import Card2 from '@/assets/image/recipient/card2.png';
import { getParameters } from '@/utils/mainUtils';
import { useHistory } from 'react-router-dom';
import { Nationality } from '@/api/auth/auth'
import { getItem, setItem } from '@/utils/secureStorage';
const { Option } = Select;

interface IInvitationPageProps {

}

const InvitationPage: FC<IInvitationPageProps> = (props) => {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const { fullName, slug } = getParameters();
  const [form] = Form.useForm();
  const [isUpdate, setIsUpdate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [bankData, setBankData] = useState<any[]>([]);
  const locale = getItem('wapipay-website-locale');
  const selectData = [
    { name: t("Upload ID card/passport"), icon: Card2, key: 'idPhoto', src: '', val: '' },
  ]
  const [fileData, setFileData] = useState<any>(selectData)
  const [users, setUsers] = useState<any[]>([]);
  const [isCny, setIsCny] = useState(false);
  const [currentReceiveType, setCurrentReceiveType] = useState<QuickPayDelivery>();
  const isLocalBank = useMemo(() => currentReceiveType === QuickPayDelivery.LocalBank, [currentReceiveType])
  const isWapiAccount = useMemo(() => currentReceiveType === QuickPayDelivery.WapipayAccount, [currentReceiveType])
  const isAlipay = useMemo(() => currentReceiveType === QuickPayDelivery.Alipay, [currentReceiveType])
  const isUPI = useMemo(() => currentReceiveType === QuickPayDelivery.UPI, [currentReceiveType])
  const isBankMasterCard = useMemo(() => currentReceiveType === QuickPayDelivery.BankMasterCard, [currentReceiveType])

  const [searchKeyword, setSearchKeyword] = useState('');
  const [fetching, setFetching] = useState<boolean>(false);
  const [idType, setIdType] = useState(1);
  const [statesList, setStatesList] = useState<{ id: string; name?: string }[]>([]);
  const [citiesList, setCitiesList] = useState<{ id: string; name?: string }[]>([]);
  const [statesLoading, setStatesLoading] = useState(false);
  const [citiesLoading, setCitiesLoading] = useState(false);
  const [payersData, setPayersData] = useState<{ banks: { bankId: string; bankName: string }[]; branches: { bankId: string; branchId: string; branchName: string; bankName: string }[] }>({ banks: [], branches: [] });
  const [payersLoading, setPayersLoading] = useState(false);
  const [alipayPayerId, setAlipayPayerId] = useState<string | null>(null);

  const onFinish = async (values: any) => {
    const { receiveType, bankCode, prefix, countryId, recipientUserId, phone } = values || {};

    if (receiveType === QuickPayDelivery.MPesa && countryId !== Nationality.Kenya) {
      message.warning(t("Sorry, M-PESA is not available in this recipient's country."))
      return;
    }
    try {
      setIsLoading(true);
      const { label } = quickPayCountryOptions.find((item: any) => item.codeVal === countryId) || {};
      const { bankName } = bankData.find((item: any) => item.bankCode === bankCode) || {};
      const params: any = {
        receiveType: receiveType + '',
        firstName: values.fullName,
        // lastName: values.lastName,
        // fullName: values.fullName,
        countryCallingCode: prefix + '',
        country: label,
        countryId,
        email: values.email,
        address: values.address,
        token: slug,
      }
      const isBankMasterCardIndia = receiveType === QuickPayDelivery.BankMasterCard && countryId === Number(quickPayRecipientNation.INR)
      const isBankMasterCardUS = receiveType === QuickPayDelivery.BankMasterCard && countryId === Number(quickPayRecipientNation.USD)
      const isBankMasterCardUK = receiveType === QuickPayDelivery.BankMasterCard && countryId === Number(quickPayRecipientNation.GBP)
      if (receiveType !== QuickPayDelivery.Alipay && receiveType !== QuickPayDelivery.UPI && !isBankMasterCardIndia && !isBankMasterCardUS && !isBankMasterCardUK) {
        params.idType = values.idType
        params.idNumber = values.idNumber
      }
      if (isWapiAccount) {
        const userItem = users.find(i => i.id === recipientUserId)
        if (!userItem || !userItem?.id) {
          message.warning(t('The user has not registered a Wapi account'))
          setIsLoading(false);
          return;
        }
        const handPhone = userItem.handPhone.replace(new RegExp('^' + prefix), '')
        params.recipientUserId = userItem.id
        params.phoneNumber = userItem.handPhone
        params.mobile = handPhone
      } else {
        params.phoneNumber = `${prefix}${phone}`
        params.mobile = `${phone}`
      }
      if (receiveType === QuickPayDelivery.LocalBank) {
        params.bankAccountNumber = values.accountNo
        params.bankName = bankName
        params.bankCode = values.bankCode
        // params.bankAccountMobile = values.bankAccountMobile
        if (isCny) {
          params.province = values.province
          params.city = values.city
          params.postalCode = values.postalCode
          params.bankBranch = values.bankBranch
          if (fileData[0]?.val) {
            params.idPhoto = fileData[0].val
          }
        }
      }
      if (receiveType === QuickPayDelivery.Alipay) {
        const stateName = statesList.find(s => String(s.id) === String(values.state))?.name
        const cityName = citiesList.find(c => String(c.id) === String(values.city))?.name
        params.state = stateName ?? values.state
        params.city = cityName ?? values.city
        params.stateId = values.state
        params.cityId = values.city
        params.stateName = stateName
        params.cityName = cityName
        if (alipayPayerId) params.payerId = alipayPayerId
      }
      if (receiveType === QuickPayDelivery.UPI) {
        const stateName = statesList.find(s => String(s.id) === String(values.state))?.name
        const cityName = citiesList.find(c => String(c.id) === String(values.city))?.name
        Object.assign(params, {
          umwid: values.upiId,
          fullName: values.fullName,
          country: label,
          countryId,
          state: stateName ?? values.state,
          city: cityName ?? values.city,
          stateId: values.state,
          cityId: values.city,
          stateName,
          cityName,
          receiveCurrency: 'INR',
          countryIsoCode: 'IN',
        })
      }
      if (receiveType === QuickPayDelivery.BankMasterCard && countryId === Number(quickPayRecipientNation.INR)) {
        const stateName = statesList.find(s => String(s.id) === String(values.state))?.name
        const cityName = citiesList.find(c => String(c.id) === String(values.city))?.name
        const selBank = payersData.banks.find((b) => b.bankId === values.bankCodeMasterCard)
        const selBranch = payersData.branches.find((b) => b.branchId === values.branchIdMasterCard)
        params.state = stateName ?? values.state
        params.city = cityName ?? values.city
        params.stateId = values.state
        params.cityId = values.city
        params.stateName = stateName
        params.cityName = cityName
        params.bankName = selBank?.bankName ?? selBranch?.bankName
        params.bankId = values.bankCodeMasterCard
        params.bankCode = values.bankCodeMasterCard
        params.bankBranch = selBranch?.branchName
        params.branchId = values.ifscCode
        params.bankAccountNumber = values.accountNoMasterCard
        params.ifscCode = values.branchIdMasterCard
      }
      if (receiveType === QuickPayDelivery.BankMasterCard && countryId === Number(quickPayRecipientNation.USD)) {
        const stateName = statesList.find(s => String(s.id) === String(values.state))?.name
        const cityName = citiesList.find(c => String(c.id) === String(values.city))?.name
        const selBank = payersData.banks.find((b) => b.bankId === values.bankCodeMasterCard)
        const selBranch = payersData.branches.find((b) => b.branchId === values.branchIdMasterCard)
        params.state = stateName ?? values.state
        params.city = cityName ?? values.city
        params.stateId = values.state
        params.cityId = values.city
        params.stateName = stateName
        params.cityName = cityName
        params.bankName = selBank?.bankName ?? selBranch?.bankName
        params.bankId = values.bankCodeMasterCard
        params.bankCode = values.bankCodeMasterCard
        params.bankBranch = selBranch?.branchName
        params.branchId = values.routingNumber
        params.bankAccountNumber = values.accountNoMasterCard
        params.routingNumber = values.routingNumber
        params.zipCode = values.zipCode
        params.receiveCurrency = 'USD'
        params.countryIsoCode = 'US'
      }
      if (receiveType === QuickPayDelivery.BankMasterCard && countryId === Number(quickPayRecipientNation.GBP)) {
        const stateName = statesList.find(s => String(s.id) === String(values.state))?.name
        const cityName = citiesList.find(c => String(c.id) === String(values.city))?.name
        const selBank = payersData.banks.find((b) => b.bankId === values.bankCodeMasterCard)
        const selBranch = payersData.branches.find((b) => b.branchId === values.branchIdMasterCard)
        params.state = stateName ?? values.state
        params.city = cityName ?? values.city
        params.stateId = values.state
        params.cityId = values.city
        params.stateName = stateName
        params.cityName = cityName
        params.bankName = selBank?.bankName ?? selBranch?.bankName
        params.bankId = values.bankCodeMasterCard
        params.bankCode = values.bankCodeMasterCard
        params.bankBranch = selBranch?.branchName
        params.branchId = values.branchIdMasterCard
        const ibanNoSpaces = (values.accountNoMasterCard ?? '').replace(/\s/g, '')
        params.bankAccountNumber = ibanNoSpaces
        params.primaryAccountNumber = ibanNoSpaces
        params.swiftCode = values.swiftCode
        params.receiveCurrency = 'GBP'
        params.countryIsoCode = 'GB'
      }
      if (receiveType === QuickPayDelivery.Alipay || receiveType === QuickPayDelivery.UPI || isBankMasterCardIndia || isBankMasterCardUS || isBankMasterCardUK) {
        params.recipientType = 'Individual'
      }
      await recipientApi.invitationAddRecipient(params, slug)
      setIsLoading(false);
      message.success(t('Added successfully'));
      history.push(`/invitationSuccess?fullName=${fullName}`)
    } catch (error) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
  }, [])

  const onFileChange = async (e: any, record: any) => {
    const { response, status, originFileObj } = e.file;
    let url = await new Promise(resolve => {
      const reader = new FileReader();
      reader.readAsDataURL(originFileObj);
      reader.onload = () => resolve(reader.result);
    });
    if (status === 'done') {
      const { data = [] } = response || {}
      const newArr = [...fileData]
      const fileSrc = data && data.length ? data[0]?.filePath : '';
      if (!fileSrc) return;
      newArr.forEach((item: any) => {
        if (item.key === record.key) {
          item.val = fileSrc;
          item.src = url;
          form.setFieldsValue({ [item.key]: url });
        }
      })
      setFileData(newArr);
    }
  }

  const onLocaleChange = (value: string) => {
    i18n.changeLanguage(value);
    setItem("wapipay-website-locale", value);
  };

  const getBanksList = async (countryCode?: string) => {
    const data = await recipientApi.queryBankList({ countryCode })
    setBankData(data)
  }

  const extractCatalogList = (res: any, statesKey = false): any[] => {
    if (!res) return []
    if (Array.isArray(res)) return res
    // API returns { States: [...] } or { Cities: [...] } with PascalCase or camelCase
    if (statesKey) {
      return res?.States ?? res?.states ?? res?.StateList ?? res?.stateList ?? res?.StateResults ?? res?.stateResults ?? res?.data ?? []
    }
    return res?.Cities ?? res?.cities ?? res?.CityList ?? res?.cityList ?? res?.CityResults ?? res?.cityResults ?? res?.data ?? res?.list ?? res?.content ?? res?.items ?? res?.records ?? res?.result ?? []
  }

  const getCatalogOptions = () => {
    const params = getParameters()
    return { tmpToken: params.slug || slug || undefined, skipGlobalError: true }
  }

  const getStatesList = async (countryIsoCode: string) => {
    if (!countryIsoCode) return
    setStatesLoading(true)
    setStatesList([])
    form.setFieldsValue({ state: undefined, city: undefined })
    setCitiesList([])
    try {
      const res: any = await recipientApi.getStatesCatalog(countryIsoCode, getCatalogOptions())
      const list = extractCatalogList(res, true)
      const getId = (o: any) => String(o?.Id ?? o?.id ?? o?.stateId ?? o?.StateId ?? o?.code ?? o?.value ?? o?.StateCode ?? o?.stateCode ?? '')
      const getName = (o: any) => String(o?.Name ?? o?.name ?? o?.stateName ?? o?.StateName ?? o?.label ?? o?.text ?? o?.description ?? '')
      const items = (list || []).map((item: any) => ({
        id: getId(item),
        name: getName(item) || getId(item)
      })).filter((item: any) => item.id != null && String(item.id).trim() !== '')
      setStatesList(Array.isArray(items) ? items : [])
    } catch (e) {
      setStatesList([])
      message.warning(t('Unable to load states. Please try again.'))
    } finally {
      setStatesLoading(false)
    }
  }

  const getCitiesList = async (countryIsoCode: string, stateId: string) => {
    if (!countryIsoCode || !stateId) return
    setCitiesLoading(true)
    form.setFieldsValue({ city: undefined })
    setPayersData({ banks: [], branches: [] })
    form.setFieldsValue({ bankCodeMasterCard: undefined, branchIdMasterCard: undefined })
    try {
      const res: any = await recipientApi.getCitiesCatalog(countryIsoCode, stateId, getCatalogOptions())
      const list = extractCatalogList(res, false)
      const getId = (o: any) => String(o?.Id ?? o?.id ?? o?.cityId ?? o?.CityId ?? o?.code ?? o?.value ?? o?.CityCode ?? o?.cityCode ?? '')
      const getName = (o: any) => String(o?.Name ?? o?.name ?? o?.cityName ?? o?.CityName ?? o?.label ?? o?.text ?? o?.description ?? '')
      const items = (list || []).map((item: any) => ({
        id: getId(item),
        name: getName(item) || getId(item)
      })).filter((item: any) => item.id != null && String(item.id).trim() !== '')
      setCitiesList(Array.isArray(items) ? items : [])
    } catch (e) {
      setCitiesList([])
      message.warning(t('Unable to load cities. Please try again.'))
    } finally {
      setCitiesLoading(false)
    }
  }

  const getPayersList = async (cityId: string, stateId?: string, countryIsoCode = 'IN', receiveCurrencyIsoCode = 'INR') => {
    if (!cityId) return
    setPayersLoading(true)
    form.setFieldsValue({ bankCodeMasterCard: undefined, branchIdMasterCard: undefined })
    setPayersData({ banks: [], branches: [] })
    try {
      const res: any = await recipientApi.getPayersCatalog({
        countryIsoCode,
        cityId: String(cityId),
        stateId: stateId ? String(stateId) : undefined,
        paymentModeId: 'C',
        receiveCurrencyIsoCode,
        sourceCurrencyIsoCode: 'KES'
      }, getCatalogOptions())
      const payers = res?.MasterPayerResults ?? res?.masterPayerResults ?? res?.data?.MasterPayerResults ?? res?.data?.masterPayerResults ?? res?.payers ?? res?.data ?? (Array.isArray(res) ? res : [])
      const branches: { bankId: string; branchId: string; branchName: string; bankName: string }[] = []
      const bankMap = new Map<string, string>()
      if (res?.banks && Array.isArray(res.banks)) {
        (res.banks as any[]).forEach((b: any) => {
          const bankId = String(b?.bankId ?? b?.id ?? b?.BankId ?? '')
          const bankName = String(b?.bankName ?? b?.name ?? b?.BankName ?? '')
          if (bankId) bankMap.set(bankId, bankName)
        })
      }
      if (res?.branches && Array.isArray(res.branches)) {
        (res.branches as any[]).forEach((b: any) => {
          const bankId = String(b?.bankId ?? b?.BankId ?? '')
          const branchId = String(b?.branchId ?? b?.id ?? b?.BranchId ?? '')
          const branchName = String(b?.branchName ?? b?.name ?? b?.BranchName ?? '')
          const bankName = String(b?.bankName ?? b?.BankName ?? bankMap.get(bankId) ?? '')
          if (bankId && branchId) {
            bankMap.set(bankId, bankName)
            branches.push({ bankId, branchId, branchName, bankName })
          }
        })
      }
      const payerList = Array.isArray(payers) ? payers : (payers ? [payers] : [])
      payerList.forEach((payer: any) => {
        const details = payer?.PayerDetailsResults ?? payer?.payerDetailsResults ?? payer?.details ?? payer?.branches ?? (Array.isArray(payer) ? payer : [])
        const detailList = Array.isArray(details) ? details : (details ? [details] : [])
        detailList.forEach((d: any) => {
          const bankId = String(d?.BankId ?? d?.bankId ?? d?.bank_id ?? payer?.PayerId ?? payer?.payerId ?? payer?.id ?? '')
          const bankName = String(d?.BankName ?? d?.bankName ?? d?.bank_name ?? payer?.PayerName ?? payer?.payerName ?? payer?.name ?? '')
          const branchId = String(d?.BranchId ?? d?.branchId ?? d?.branch_id ?? d?.id ?? '')
          const branchName = String(d?.BranchName ?? d?.branchName ?? d?.branch_name ?? d?.name ?? '')
          if (bankId && branchId) {
            bankMap.set(bankId, bankName)
            branches.push({ bankId, branchId, branchName, bankName })
          }
        })
      })
      const banks = Array.from(bankMap.entries()).map(([bankId, bankName]) => ({ bankId, bankName }))
      setPayersData({ banks, branches })
    } catch (e) {
      setPayersData({ banks: [], branches: [] })
      message.warning(t('Unable to load bank options. Please try again.'))
    } finally {
      setPayersLoading(false)
    }
  }

  const getAlipayPayersList = async (cityId: string, stateId?: string) => {
    if (!cityId) return
    setAlipayPayerId(null)
    try {
      const res: any = await recipientApi.getPayersCatalog({
        countryIsoCode: 'CN',
        cityId: String(cityId),
        stateId: stateId ? String(stateId) : undefined,
        paymentModeId: 'W',
        receiveCurrencyIsoCode: 'CNY',
        sourceCurrencyIsoCode: 'KES'
      }, getCatalogOptions())
      const payers = res?.MasterPayerResults ?? res?.masterPayerResults ?? res?.data?.MasterPayerResults ?? res?.data?.masterPayerResults ?? []
      const firstPayer = payers?.[0]
      const payerId = firstPayer ? String(firstPayer?.PayerId ?? firstPayer?.payerId ?? firstPayer?.id ?? '') : ''
      if (payerId) setAlipayPayerId(payerId)
    } catch (_e) {
      setAlipayPayerId(null)
    }
  }

  const getUsersList = async (keyword: string) => {
    setSearchKeyword(keyword)
    if (!keyword) {
      setUsers([])
      return
    }
    try {
      setFetching(true)
      const prefix = form.getFieldValue('prefix')
      const searchRes = await recipientApi.invitationPageSearchUser({ keyword: `${prefix}${keyword}` }, slug)
      setUsers(searchRes || [])
      setFetching(false)
    } catch (error) {
      setFetching(false)
    }
  };

  const fetchUsers = _.debounce(getUsersList, 800);

  // const disabledSubmit = () => {
  //   if (!regularData.email.test(form.getFieldValue('email'))) {
  //     return true
  //   }
  //   if (!isWapiAccount && !regularData.phone.test(form.getFieldValue('phone'))) {
  //     return true
  //   }
  //   switch (currentReceiveType) {
  //     case QuickPayDelivery.LocalBank:
  //       if (!checkDisabled(form, isCny ? 16 : 12)) {
  //         return true
  //       }
  //       break;
  //     default:
  //       if (!checkDisabled(form, 9)) {
  //         return true
  //       }
  //   }
  //   return false
  // }

  const disabledSubmit = () => {
    if (!regularData.email.test(form.getFieldValue('email'))) {
      return true;
    }
    if (!isWapiAccount && !regularData.phone.test(form.getFieldValue('phone'))) {
      return true;
    }

    if (currentReceiveType === QuickPayDelivery.LocalBank) {
      // For Local Bank in China (CNY), more fields are required
      const requiredFields = isCny
        ? [
          'receiveType',
          'countryId',
          'fullName',
          'idType',
          'idNumber',
          'email',
          'phone',
          'address',
          'bankCode',
          'bankBranch',
          'accountNo',
          'province',
          'city',
          'postalCode'
        ]
        : [
          'receiveType',
          'countryId',
          'fullName',
          'idType',
          'idNumber',
          'email',
          'phone',
          'address',
          'bankCode',
          'bankBranch',
          'accountNo'
        ];

      return requiredFields.some(f => !form.getFieldValue(f));
    }

    if (currentReceiveType === QuickPayDelivery.Alipay) {
      const alipayFields = [
        'receiveType',
        'countryId',
        'fullName',
        'email',
        'phone',
        'state',
        'city',
        'address'
      ];
      return alipayFields.some(f => !form.getFieldValue(f));
    }

    if (currentReceiveType === QuickPayDelivery.UPI) {
      const upiFields = [
        'receiveType',
        'countryId',
        'fullName',
        'email',
        'phone',
        'upiId',
        'state',
        'city',
        'address'
      ];
      return upiFields.some(f => !form.getFieldValue(f));
    }

    if (currentReceiveType === QuickPayDelivery.BankMasterCard && form.getFieldValue('countryId') === Number(quickPayRecipientNation.INR)) {
      const bmcFields = [
        'receiveType',
        'countryId',
        'fullName',
        'email',
        'phone',
        'address',
        'state',
        'city',
        'bankCodeMasterCard',
        'branchIdMasterCard',
        'accountNoMasterCard',
        'ifscCode'
      ];
      return bmcFields.some(f => !form.getFieldValue(f));
    }
    if (currentReceiveType === QuickPayDelivery.BankMasterCard && form.getFieldValue('countryId') === Number(quickPayRecipientNation.USD)) {
      const bmcUSFields = [
        'receiveType',
        'countryId',
        'fullName',
        'email',
        'phone',
        'address',
        'state',
        'city',
        'bankCodeMasterCard',
        'branchIdMasterCard',
        'accountNoMasterCard',
        'routingNumber',
        'zipCode'
      ];
      return bmcUSFields.some(f => !form.getFieldValue(f));
    }
    if (currentReceiveType === QuickPayDelivery.BankMasterCard && form.getFieldValue('countryId') === Number(quickPayRecipientNation.GBP)) {
      const bmcUKFields = [
        'receiveType',
        'countryId',
        'fullName',
        'email',
        'phone',
        'address',
        'state',
        'city',
        'bankCodeMasterCard',
        'branchIdMasterCard',
        'accountNoMasterCard',
        'swiftCode'
      ];
      return bmcUKFields.some(f => !form.getFieldValue(f));
    }

    // Default case (Wechat, M-Pesa,)
    const defaultFields = [
      'receiveType',
      'countryId',
      'fullName',
      'idType',
      'idNumber',
      'email',
      'phone',
      'address'
    ];
    return defaultFields.some(f => !form.getFieldValue(f));
  };



  return (
    <div className={`${styles.root}`}>
      <HeadComponent isHideHome />
      <div className='login-form-container'>
        <Form
          form={form}
          onFinish={onFinish}
          className="login-form"
          onValuesChange={() => setIsUpdate(!isUpdate)}
          initialValues={{ prefix: 254, country: 2 }}
        >
          <div className={styles.title}>{fullName ? `${fullName.replace("-", " ")}` : ''}{t(" Wants To transfer money to you, please provide your information below.")}</div>
          <div className={styles.formBox}>
            <div className={styles.formTitle}>{t("personal information")}</div>
            <DefaultSelect
              dropdownMatchSelectWidth={false}
              formItemLabel={t("Payment method")}
              formItemName="receiveType"
              onChange={(val: any) => {
                setCurrentReceiveType(val)
                const countryId = form.getFieldValue('countryId')
                if (countryId && (val === QuickPayDelivery.LocalBank || val === QuickPayDelivery.BankMasterCard)) {
                  getBanksList(countryId)
                }
                if ((val === QuickPayDelivery.Alipay || val === QuickPayDelivery.UPI || val === QuickPayDelivery.BankMasterCard) && countryId) {
                  const countryItem = quickPayCountryOptions.find((item: any) => String(item.codeVal) === String(countryId) || item.codeVal === countryId)
                  const isBMCIndiaUSOrUK = val === QuickPayDelivery.BankMasterCard && (countryId === Number(quickPayRecipientNation.INR) || countryId === Number(quickPayRecipientNation.USD) || countryId === Number(quickPayRecipientNation.GBP))
                  if (countryItem?.countryIso && (val !== QuickPayDelivery.BankMasterCard || isBMCIndiaUSOrUK)) {
                    getStatesList(countryItem.countryIso)
                  }
                }
                if (val !== QuickPayDelivery.Alipay && val !== QuickPayDelivery.UPI && !(val === QuickPayDelivery.BankMasterCard && (countryId === Number(quickPayRecipientNation.INR) || countryId === Number(quickPayRecipientNation.USD) || countryId === Number(quickPayRecipientNation.GBP)))) {
                  form.resetFields(['state', 'city', 'bankCodeMasterCard', 'branchIdMasterCard'])
                  setStatesList([])
                  setCitiesList([])
                  setPayersData({ banks: [], branches: [] })
                  setAlipayPayerId(null)
                }
              }}
            >
              {
                quickPayDeliveryOptions.map(v =>
                  <Option
                    value={v.value}
                    key={v.value}>
                    {v.label}
                  </Option>)
              }
            </DefaultSelect>
            <SelectPicture
              formItemName="countryId"
              placeholder={t("Recipient Country")}
              formItemLabel={t("Recipient Country")}
              optionLabelProp="label"
              optionData={quickPayCountryOptions}
              valueKey="codeVal"
              onChange={(val: any) => {
                const countryItem = quickPayCountryOptions.find((item: any) => String(item.codeVal) === String(val) || item.codeVal === val);
                const { value, countryIso } = countryItem || {};
                form.setFieldsValue({ prefix: value });
                form.resetFields(['bankCode', 'recipientUserId'])
                setUsers([])
                const receiveType = form.getFieldValue('receiveType')
                if (receiveType === QuickPayDelivery.LocalBank || receiveType === QuickPayDelivery.BankMasterCard) {
                  getBanksList(val)
                }
                const isBMCIndiaUSOrUK = receiveType === QuickPayDelivery.BankMasterCard && (val === Number(quickPayRecipientNation.INR) || val === Number(quickPayRecipientNation.USD) || val === Number(quickPayRecipientNation.GBP))
                if ((receiveType === QuickPayDelivery.Alipay || receiveType === QuickPayDelivery.UPI || isBMCIndiaUSOrUK) && countryIso) {
                  getStatesList(countryIso)
                } else if (receiveType === QuickPayDelivery.Alipay || receiveType === QuickPayDelivery.UPI || (receiveType === QuickPayDelivery.BankMasterCard && !isBMCIndiaUSOrUK)) {
                  form.resetFields(['state', 'city', 'bankCodeMasterCard', 'branchIdMasterCard'])
                  setStatesList([])
                  setCitiesList([])
                  setPayersData({ banks: [], branches: [] })
                  setAlipayPayerId(null)
                }
                setIsCny(val === Number(quickPayRecipientNation.CNY))
              }}
            />
            <DefaultInput
              formItemName="fullName"

              placeholder={
                currentReceiveType === QuickPayDelivery.Wechat
                  ? t("Payee Name ")
                  : (isLocalBank && isCny
                    ? t("Payee Name ")
                    : t("Payee Name"))

              }
              notes={
                currentReceiveType === QuickPayDelivery.Wechat
                  ? t("To ensure accurate payment, please fill in all information in English.")
                  : (isLocalBank && isCny
                    ? t("When receiving payment at Bank of China, your name must be in Chinese.")
                    : undefined)
              }
              rules={[


                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value) {
                      // Dynamic error for empty field
                      if (currentReceiveType === QuickPayDelivery.Wechat) {
                        return Promise.reject(t("Please fill in your name in English"));
                      }
                      if (isLocalBank && isCny) {
                        return Promise.reject(t("Please fill in your name in Chinese"));
                      }
                      return Promise.reject(t("Please fill in your name"));
                    }

                    //  Validation for WeChat (must be English letters only)
                    if (currentReceiveType === QuickPayDelivery.Wechat) {
                      const englishOnly = /^[A-Za-z\s]+$/;
                      return englishOnly.test(value)
                        ? Promise.resolve()
                        : Promise.reject(t("Please fill in your name in English"));
                    }

                    //  Validation for China Local Bank (must be Chinese characters)
                    if (isLocalBank && isCny) {
                      const chineseOnly = /[\u4e00-\u9fa5]/;
                      return chineseOnly.test(value)
                        ? Promise.resolve()
                        : Promise.reject(t("Please fill in your name in Chinese"));
                    }

                    return Promise.resolve();
                  }
                })
              ]}

              tipsStyle={{ bottom: '-15px' }}
            />

            <div className={`form-item-warp ${styles.phoneWrap}`}>
              <Form.Item name="prefix" noStyle>
                <Select
                  style={{ minWidth: 80 }}
                  optionLabelProp="label"
                  dropdownMatchSelectWidth={false}
                  dropdownStyle={{ width: 250 }}
                >
                  {
                    quickPayCountryOptions.map((item: any) => (
                      <Option
                        value={item.value}
                        key={`${item.value}`}
                        label={
                          <div className='flex-center'>
                            <img
                              src={item.icon}
                              className="country-logo"
                              style={{ width: 21, marginRight: 5 }}
                              alt=''
                            /> <span>{item.code}</span>
                          </div>
                        }
                      >
                        <div className='flex-center'>
                          <img
                            src={item.icon}
                            className="country-logo"
                            style={{ width: 24, marginRight: 8 }}
                            alt=''
                          /> {item.label} {item.code}
                        </div>
                      </Option>
                    ))
                  }
                </Select>
              </Form.Item>
              {isWapiAccount ? <DefaultSelect
                formItemName="recipientUserId"
                placeholder={t('Recipients mobile phone number')}
                otherSelectProps={{
                  onSearch: fetchUsers,
                  filterOption: false,
                  notFoundContent: fetching ? <Spin size="small" /> : <div>{searchKeyword ? t('The user has not registered a Wapi account') : t('not found')}</div>,
                  showSearch: true,
                  style: {
                    width: '100%'
                  }
                }}
                otherFormItemProps={{
                  noStyle: true
                }}
                containerClassName={styles.phoneItem}
              >
                {
                  users.map((item: any) => (
                    <Option
                      value={item.id}
                      key={item.id}
                    >
                      {item.firstName} {item.lastName} ({item.handPhone})
                    </Option>
                  ))
                }
              </DefaultSelect> : <DefaultInput
                warpStyle={{ width: '100%' }}
                formItemProps={{
                  noStyle: true


                }}
                formItemName="phone"
                placeholder={t("Recipient's mobile phone number")}
                inputType="number"
                regular={/^\d+$/}

              />}

            </div>
            {!isAlipay && !isUPI && !(isBankMasterCard && (form.getFieldValue('countryId') === Number(quickPayRecipientNation.INR) || form.getFieldValue('countryId') === Number(quickPayRecipientNation.USD) || form.getFieldValue('countryId') === Number(quickPayRecipientNation.GBP))) && <>
              <DefaultSelect
                dropdownMatchSelectWidth={false}
                placeholder={t("身份证类型")}
                formItemName="idType"
                onChange={(v) => {
                  setIdType(v)
                }}
              >
                <Option value={1}>
                  {t("身份证")}
                </Option>
                <Option value={2}>
                  {t("护照")}
                </Option>
              </DefaultSelect>
              <DefaultInput
                formItemName="idNumber"
                placeholder={isLocalBank ? (idType === 2 ? t("开户时使用的护照") : t("开户时使用的身份证号")) : (idType === 2 ? t("护照") : t("身份证号"))}
                formItemTips={`${t("请输入")}${idType === 2 ? t("护照") : t("身份证号")}`}
              />
            </>}
            <DefaultInput
              formItemName="email"
              placeholder={t("电子邮箱")}
              regular={regularData.email}
              inputBlurFn={() => {
                const email = form.getFieldValue('email')
                if (email) {
                  form.setFieldsValue({ email: email.toLowerCase() })
                }
              }}
            />
            {isUPI && (
              <DefaultInput
                formItemName="upiId"
                formItemLabel="UPI ID"
                placeholder="UPI ID"
              />
            )}
            {(isAlipay || isUPI || (isBankMasterCard && (form.getFieldValue('countryId') === Number(quickPayRecipientNation.INR) || form.getFieldValue('countryId') === Number(quickPayRecipientNation.USD) || form.getFieldValue('countryId') === Number(quickPayRecipientNation.GBP)))) && <>
              <DefaultSelect
                formItemName="state"
                formItemLabel={t("州")}
                placeholder={t("州")}
                otherSelectProps={{ showSearch: true, optionFilterProp: 'children', filterOption: (input: string, opt: any) => (opt?.children ?? '').toString().toLowerCase().includes(input.toLowerCase()), loading: statesLoading, notFoundContent: statesLoading ? <Spin size="small" /> : null }}
                onChange={(stateId: string) => {
                  const countryId = form.getFieldValue('countryId')
                  const countryItem = quickPayCountryOptions.find((item: any) => String(item.codeVal) === String(countryId) || item.codeVal === countryId)
                  if (countryItem?.countryIso && stateId) {
                    getCitiesList(countryItem.countryIso, stateId)
                  } else {
                    setCitiesList([])
                  }
                }}
              >
                {statesList.map((item) => (
                  <Option value={item.id} key={item.id}>
                    {item.name ?? item.id}
                  </Option>
                ))}
              </DefaultSelect>
              <DefaultSelect
                formItemName="city"
                formItemLabel={t("城市")}
                placeholder={t("城市")}
                otherSelectProps={{ showSearch: true, optionFilterProp: 'children', filterOption: (input: string, opt: any) => (opt?.children ?? '').toString().toLowerCase().includes(input.toLowerCase()), loading: citiesLoading, notFoundContent: citiesLoading ? <Spin size="small" /> : null }}
                onChange={(cityId: string) => {
                  const countryId = form.getFieldValue('countryId')
                  const isBMCIndia = isBankMasterCard && countryId === Number(quickPayRecipientNation.INR)
                  const isBMCUS = isBankMasterCard && countryId === Number(quickPayRecipientNation.USD)
                  const isBMCUK = isBankMasterCard && countryId === Number(quickPayRecipientNation.GBP)
                  if (isBMCIndia && cityId) {
                    const stateId = form.getFieldValue('state')
                    getPayersList(cityId, stateId, 'IN', 'INR')
                  } else if (isBMCUS && cityId) {
                    const stateId = form.getFieldValue('state')
                    getPayersList(cityId, stateId, 'US', 'USD')
                  } else if (isBMCUK && cityId) {
                    const stateId = form.getFieldValue('state')
                    getPayersList(cityId, stateId, 'GB', 'GBP')
                  } else if (isAlipay && cityId) {
                    const stateId = form.getFieldValue('state')
                    getAlipayPayersList(cityId, stateId)
                  } else {
                    setPayersData({ banks: [], branches: [] })
                    if (!isAlipay) setAlipayPayerId(null)
                  }
                }}
              >
                {citiesList.map((item) => (
                  <Option value={item.id} key={item.id}>
                    {item.name ?? item.id}
                  </Option>
                ))}
              </DefaultSelect>
            </>}
            {(isBankMasterCard && form.getFieldValue('countryId') === Number(quickPayRecipientNation.INR)) && (
              <>
                <div className={styles.formTitle}>Bank Information</div>
                <DefaultSelect
                  formItemName="bankCodeMasterCard"
                  formItemLabel="Bank Name"
                  placeholder="Bank Name"
                  otherSelectProps={{ showSearch: true, optionFilterProp: 'children', filterOption: (input: string, opt: any) => (opt?.children ?? '').toString().toLowerCase().includes(input.toLowerCase()), loading: payersLoading, notFoundContent: payersLoading ? <Spin size="small" /> : null }}
                  onChange={() => form.setFieldsValue({ branchIdMasterCard: undefined })}
                >
                  {payersData.banks.map((item) => (
                    <Option value={item.bankId} key={item.bankId}>
                      {item.bankName}
                    </Option>
                  ))}
                </DefaultSelect>
                <DefaultSelect
                  formItemName="branchIdMasterCard"
                  formItemLabel="Branch Name"
                  placeholder="Branch Name"
                  otherSelectProps={{ showSearch: true, optionFilterProp: 'children', filterOption: (input: string, opt: any) => (opt?.children ?? '').toString().toLowerCase().includes(input.toLowerCase()), loading: payersLoading, notFoundContent: payersLoading ? <Spin size="small" /> : null }}
                >
                  {payersData.branches
                    .filter((b) => b.bankId === form.getFieldValue('bankCodeMasterCard'))
                    .map((item) => (
                      <Option value={item.branchId} key={item.branchId}>
                        {item.branchName}
                      </Option>
                    ))}
                </DefaultSelect>
                <DefaultInput
                  formItemName="accountNoMasterCard"
                  formItemLabel="Bank Account Number"
                  placeholder="Bank Account Number"
                  inputType="number"
                  regular={/^\d+$/}
                />
                <DefaultInput
                  formItemName="ifscCode"
                  formItemLabel="IFSC Code"
                  placeholder="IFSC Code"
                />
              </>
            )}
            {(isBankMasterCard && form.getFieldValue('countryId') === Number(quickPayRecipientNation.USD)) && (
              <>
                <div className={styles.formTitle}>Bank Information</div>
                <DefaultSelect
                  formItemName="bankCodeMasterCard"
                  formItemLabel="Bank Name"
                  placeholder="Bank Name"
                  otherSelectProps={{ showSearch: true, optionFilterProp: 'children', filterOption: (input: string, opt: any) => (opt?.children ?? '').toString().toLowerCase().includes(input.toLowerCase()), loading: payersLoading, notFoundContent: payersLoading ? <Spin size="small" /> : null }}
                  onChange={() => form.setFieldsValue({ branchIdMasterCard: undefined })}
                >
                  {payersData.banks.map((item) => (
                    <Option value={item.bankId} key={item.bankId}>
                      {item.bankName}
                    </Option>
                  ))}
                </DefaultSelect>
                <DefaultSelect
                  formItemName="branchIdMasterCard"
                  formItemLabel="Branch Name"
                  placeholder="Branch Name"
                  otherSelectProps={{ showSearch: true, optionFilterProp: 'children', filterOption: (input: string, opt: any) => (opt?.children ?? '').toString().toLowerCase().includes(input.toLowerCase()), loading: payersLoading, notFoundContent: payersLoading ? <Spin size="small" /> : null }}
                >
                  {payersData.branches
                    .filter((b) => b.bankId === form.getFieldValue('bankCodeMasterCard'))
                    .map((item) => (
                      <Option value={item.branchId} key={item.branchId}>
                        {item.branchName}
                      </Option>
                    ))}
                </DefaultSelect>
                <DefaultInput
                  formItemName="accountNoMasterCard"
                  formItemLabel="Bank Account Number"
                  placeholder="Bank Account Number"
                  inputType="number"
                  regular={/^\d+$/}
                />
                <DefaultInput
                  formItemName="routingNumber"
                  formItemLabel="Routing Id Number (RTN)"
                  placeholder="Routing Id Number (RTN)"
                />
                <DefaultInput
                  formItemName="zipCode"
                  formItemLabel="Zip Code"
                  placeholder="Zip Code"
                />
              </>
            )}
            {(isBankMasterCard && form.getFieldValue('countryId') === Number(quickPayRecipientNation.GBP)) && (
              <>
                <div className={styles.formTitle}>Bank Information</div>
                <DefaultSelect
                  formItemName="bankCodeMasterCard"
                  formItemLabel="Bank Name"
                  placeholder="Bank Name"
                  otherSelectProps={{ showSearch: true, optionFilterProp: 'children', filterOption: (input: string, opt: any) => (opt?.children ?? '').toString().toLowerCase().includes(input.toLowerCase()), loading: payersLoading, notFoundContent: payersLoading ? <Spin size="small" /> : null }}
                  onChange={() => form.setFieldsValue({ branchIdMasterCard: undefined })}
                >
                  {payersData.banks.map((item) => (
                    <Option value={item.bankId} key={item.bankId}>
                      {item.bankName}
                    </Option>
                  ))}
                </DefaultSelect>
                <DefaultSelect
                  formItemName="branchIdMasterCard"
                  formItemLabel="Branch Name"
                  placeholder="Branch Name"
                  otherSelectProps={{ showSearch: true, optionFilterProp: 'children', filterOption: (input: string, opt: any) => (opt?.children ?? '').toString().toLowerCase().includes(input.toLowerCase()), loading: payersLoading, notFoundContent: payersLoading ? <Spin size="small" /> : null }}
                >
                  {payersData.branches
                    .filter((b) => b.bankId === form.getFieldValue('bankCodeMasterCard'))
                    .map((item) => (
                      <Option value={item.branchId} key={item.branchId}>
                        {item.branchName}
                      </Option>
                    ))}
                </DefaultSelect>
                <DefaultInput
                  formItemName="accountNoMasterCard"
                  formItemLabel="IBAN Number"
                  placeholder="IBAN Number"
                />
                <DefaultInput
                  formItemName="swiftCode"
                  formItemLabel="Swift Code"
                  placeholder="Swift Code"
                />
              </>
            )}
            {isLocalBank && isCny && <>
              <DefaultInput
                formItemName="province"
                placeholder={t("省")}
              />
              <DefaultInput
                formItemName="city"
                placeholder={t("城市")}
              />
              <DefaultInput
                formItemName="postalCode"
                placeholder={t("邮政编码")}
              // option={true}
              />
            </>}
            <DefaultInput
              formItemName="address"
              placeholder={t("地址")}
            />
            {
              isLocalBank && (
                <>
                  <div className={styles.formTitle}>{t("银行信息")}</div>
                  <DefaultSelect
                    formItemName="bankCode"
                    placeholder={t("银行名称")}
                  >
                    {
                      bankData.map((item: any) => (
                        <Option
                          value={item.bankCode}
                          key={item.id}
                        >
                          {item.bankName}
                        </Option>
                      ))
                    }
                  </DefaultSelect>
                  <DefaultInput
                    formItemName="bankBranch"
                    placeholder={t("银行支行")}
                  />
                  <DefaultInput
                    formItemName="accountNo"
                    placeholder={t("收款人银行账号")}
                    inputType="number"
                    regular={/^\d+$/}
                  />
                  {/* <DefaultInput
                    formItemName="bankAccountMobile"
                    placeholder={t("开户时使用的电话号码")}
                    inputType="number"
                   regular={/^\d+$/}
                  /> */}
                </>
              )
            }
            {isLocalBank && isCny && <>
              <div className={styles.formTitle}>{t("文件")}({t("可选")})</div>
              <div className={styles.selectList}>
                {
                  fileData.map((item: any) => (
                    <div
                      className={styles.selectLi}
                      key={item.name}
                    >
                      <UploadComponent
                        onChange={(e) => onFileChange(e, item)}
                        maxCount={1}
                        showUploadList={false}
                      >
                        {
                          item.src ? (
                            <div className={styles.picWarp}>
                              <img src={item.src} className={styles.pic} alt='' />
                              <div className={styles.text}>{t("重新上传")}</div>
                            </div>
                          ) : (
                            <img src={item.icon} className={styles.icon} alt='' />
                          )
                        }

                      </UploadComponent>
                      {/* <div className={styles.name}>{item.name}</div> */}
                    </div>
                  ))
                }
              </div>
            </>}
          </div>
          <div className={styles.btnWarp}>
            <Button
              disabled={disabledSubmit()}
              type="primary"
              htmlType="submit"
              loading={isLoading}
              className='submit-button'
            >
              {t("提交")}
            </Button>
          </div>
        </Form>
      </div>
      <div className={`${styles['language-box']}`}>
        <div className={`${styles['language-li']}`} onClick={() => { onLocaleChange('zh') }}>中文</div>
        <div className={`${styles['language-li']}`} onClick={() => { onLocaleChange('en') }}>English</div>
      </div>
      <FooterComponent />
    </div>
  )
}

export default InvitationPage